export const getCurrentLocation = () => ({
  pathname: window.location.pathname || "/",
  hash: window.location.hash || "",
});

export const navigateTo = (path) => {
  if (`${window.location.pathname}${window.location.hash}` === path) {
    return;
  }

  window.history.pushState({}, "", path);
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const navigateToHomeSection = (sectionId) => {
  if (window.location.pathname !== "/") {
    navigateTo(`/#${sectionId}`);
    return;
  }

  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
    if (window.location.hash !== `#${sectionId}`) {
      window.history.replaceState({}, "", `/#${sectionId}`);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }
};
